/**
 * 브랜드 허브 상세가 그대로 적는 화면 문구.
 */

import { TOTAL_REACH_FORMULA } from 'src/utils/metrics/total-reach';

import { BRAND_HUB_CREATOR_LIST } from './brand-hub-face-size';

/** 목록 머리 검색칸의 자리표시 */
export const BRAND_HUB_SEARCH_PLACEHOLDER = '브랜드 이름으로 찾기 · Enter 로 열기';

/**
 * 크리에이터를 세우는 잣대 — **인기순이 기본**이다.
 * ⚠️ 이름이 곧 뜻이라야 한다 — 인기순은 「총도달이 큰 사람」 · 포스팅수는 「많이 올린 사람」 · 최근 순은 「마지막 글이 최근인 사람」이다.
 */
export const BRAND_HUB_CREATOR_ORDERS = [
  { value: 'reach', label: '인기순' },
  { value: 'count', label: '포스팅수' },
  { value: 'recent', label: '최근 순' },
];

/**
 * 실시간 보강 중임을 알리는 말 — **띠와 빈 자리가 같은 말**을 해야 한다.
 * 🔑 「없습니다」만 뜨면 사용자가 **기다리면 되는지**를 모른다. 왜 도는지는 적지 않는다.
 */
export const BRAND_HUB_LIVE_AD_LABEL = '광고를 최신 정보로 갱신하고 있어요';
export const BRAND_HUB_LIVE_PRODUCT_LABEL = '판매몰 상품을 최신 정보로 갱신하고 있어요';

/**
 * 구역 제목 옆 ⓘ 툴팁의 고정 줄 — 조건에 따라 갈리는 줄은 `utils/brand-hub-face-hint` 가 짓는다.
 * 명사형 한 줄씩 — 집계 기준 · 정렬처럼 숫자를 바르게 읽는 데 필요한 것만.
 */
export const BRAND_HUB_CONTENT_INFO: readonly string[] = ['반응 좋은 순'];
export const BRAND_HUB_CREATORS_INFO: readonly string[] = [
  '이 브랜드를 언급한 글만 집계',
  'SNS 다섯 채널만: 인스타그램 · 틱톡 · 유튜브 · X · 스레드',
  `표: 인기순·포스팅수 상위 ${BRAND_HUB_CREATOR_LIST}명`,
  `총도달: ${TOTAL_REACH_FORMULA}`,
  `평균 대비: 표의 ${BRAND_HUB_CREATOR_LIST}명 전체 글당 평균 총도달과 비교`,
  '최근 순: 인기순 상위 크리에이터를 마지막 글 날로 정렬',
  '성별·연령대·규모 필터: 판별된 크리에이터만 남음',
];
export const BRAND_HUB_ACCOUNTS_INFO: readonly string[] = ['이 브랜드 언급 글 수 순', 'SNS 다섯 채널만: 인스타그램 · 틱톡 · 유튜브 · X · 스레드'];
/** 추이 — 피벗이 `beautyEval` + `basicOnly` 짝을 켜서 머리 요약과 모수를 맞춘다 */
export const BRAND_HUB_PIVOT_INFO: readonly string[] = ['뷰티 판별 글만 집계'];

/** 채널·국가 비중 도넛에 이름표를 다는 수 — 그 아래는 「그 밖」 한 조각이다 */
export const BRAND_HUB_MIX_LEGEND = 5;
export const BRAND_HUB_MIX_INFO: readonly string[] = ['뷰티 판별 글만 집계', `상위 ${BRAND_HUB_MIX_LEGEND}개 외에는 「그 밖」으로 묶음`];
